export default __webpack_public_path__ + "static/media/s4_xit-spring.6c44042c.png";